import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Box, Drawer, Typography, LinearProgress, IconButton, Badge, Paper } from '@mui/material';
import { ExpandLess, ExpandMore, Close } from '@mui/icons-material';

const QueueProgressDrawer = () => {
  const queue = useSelector((state) => state.queue);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (queue.length > 0 && !open) {
      setOpen(true);
    } else if (queue.length === 0 && open) {
      setOpen(false);
    }
  }, [queue, open]);

  const toggleDrawer = () => {
    setOpen(!open);
  };

  const getStepLabel = (item) => {
    if (!item.isStarted) return 'Queued';
    return item.step.charAt(0).toUpperCase() + item.step.slice(1);
  };

  if (queue.length === 0) {
    return null;
  }

  return (
    <>
      <Drawer
        anchor="bottom"
        open={open}
        variant="persistent"
        PaperProps={{
          sx: {
            width: '400px',
            height: 'auto',
            maxHeight: '70%',
            overflow: 'hidden',
            bottom: '0 !important',
            right: '100px !important',
            left: 'auto !important',
            borderTopLeftRadius: '8px',
            borderTopRightRadius: '8px',
            boxShadow: '0px -2px 10px rgba(0,0,0,0.1)',
          },
        }}
      >
        <Paper elevation={0} sx={{ borderBottom: '1px solid rgba(0, 0, 0, 0.12)' }}>
          <Box sx={{ p: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="subtitle1" fontWeight="bold">
              Queue Progress
            </Typography>
            <Box>
              <IconButton size="small" onClick={toggleDrawer}>
                {open ? <ExpandMore /> : <ExpandLess />}
              </IconButton>
              <IconButton size="small" onClick={() => setOpen(false)}>
                <Close />
              </IconButton>
            </Box>
          </Box>
        </Paper>
        <Box sx={{ p: 2, maxHeight: 'calc(70vh - 56px)', overflowY: 'auto' }}>
          {queue.map((item) => (
            <Box key={item.queryID} sx={{ mb: 2 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                <Typography variant="body2" color="text.secondary">
                  Query ID: {item.queryID}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {getStepLabel(item)}
                </Typography>
              </Box>
              <LinearProgress
                variant="determinate"
                value={item.progress || 0}
                sx={{
                  height: 4,
                  borderRadius: 2,
                  backgroundColor: 'rgba(0, 0, 0, 0.08)',
                  '& .MuiLinearProgress-bar': {
                    backgroundColor: '#4285F4',
                  },
                }}
              />
            </Box>
          ))}
        </Box>
      </Drawer>
      {!open && (
        <Badge
          badgeContent={queue.length}
          color="primary"
          sx={{
            position: 'fixed',
            bottom: 16,
            right: 116,
            transition: 'all 0.3s',
          }}
        >
          <Paper
            elevation={2}
            sx={{
              borderRadius: '20px',
              overflow: 'hidden',
            }}
          >
            <IconButton
              onClick={toggleDrawer}
              sx={{
                bgcolor: 'background.paper',
                '&:hover': { bgcolor: 'background.paper' },
              }}
            >
              <ExpandLess />
            </IconButton>
          </Paper>
        </Badge>
      )}
    </>
  );
};

export default QueueProgressDrawer;
